exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".EditUser__select___2PJGa {\n  margin-top: 4px;\n}\n\n.EditUser__address___uis6C {\n  border: 1px solid #8c9fed;\n  border-radius: 4px;\n  display: block;\n  min-height: 55px;\n  font-size: 14px;\n  margin-top: 4px;\n  width: 245px;\n}\n\n.EditUser__section___1vvnv {\n  margin-top: 12px;\n}\n\n.EditUser__evening___10wn0 {\n  margin-top: 4px;\n}\n", ""]);

// exports
exports.locals = {
	"select": "EditUser__select___2PJGa",
	"address": "EditUser__address___uis6C",
	"section": "EditUser__section___1vvnv",
	"evening": "EditUser__evening___10wn0"
};